import { Link } from 'react-router-dom';
import { useSeo } from '@/hooks/useSeo';

const faqs = [
  {
    q: '什么是今日同人库？',
    a: '今日同人库是一个每日整理同人作品更新动态的资讯站点，汇总当日今日更新、最新汉化与新作连载进度，帮助读者集中追更，不再错过章节。',
  },
  {
    q: '如何知道某部作品今天是否更新？',
    a: '进入首页「今日更新速递」板块即可查看当日更新作品与最新章节标题，也可以在「全部更新」页面按分类和连载状态筛选，关注作品的更新一目了然。',
  },
  {
    q: '作品的汉化进度在哪里查看？',
    a: '进入作品详情页可以看到最新汉化章节与已汉化章节数。标记为「汉化完成」的作品表示全部分卷均已汉化完结，标记为「连载中」的作品仍在稳定更新。',
  },
  {
    q: '新作连载的预告信息从哪里获取？',
    a: '在首页「汉化连载·追更推荐」板块的「新作预告」分栏，以及各分类页顶部，都会展示即将开坑的新作名称与上线时间。',
  },
  {
    q: '我该如何订阅更新提醒？',
    a: '在页面底部「订阅更新速递」处留下邮箱，即可在每日更新整理完成后收到推送提醒，第一时间掌握今日同人库今日更新动态。',
  },
  {
    q: '今日更新一般什么时间整理完毕？',
    a: '每日更新通常在晚间完成整理并在次日零点前更新到位。若遇节假日或汉化组更新较晚，个别作品会顺延至次日凌晨补充。',
  },
  {
    q: '本站收录的作品可以在这里直接阅读吗？',
    a: '本站是更新追踪与资讯整理站点，仅展示更新动态、最新章节标题与内容节选，不提供完整作品在线阅读。请支持原作者与汉化组。',
  },
  {
    q: '如果发现更新信息有误该如何反馈？',
    a: '欢迎通过「联系我们」页面留言，说明作品名称与正确的更新状态，我们会尽快核实并修正，感谢你的监督与支持。',
  },
];

export default function FaqPage() {
  useSeo({
    title: '追更指南与常见问题 - 今日同人库',
    description:
      '关于今日同人库的使用方式、今日更新机制、汉化进度说明与订阅提醒的常见问题解答，帮助你更高效地追更今日同人库更新。',
    keywords: '今日同人库,追更指南,今日同人库更新,汉化进度,常见问题',
  });

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <div className="bg-secondary-50/70 px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-4xl mx-auto">
          <nav className="text-sm text-foreground-500 mb-3" aria-label="面包屑">
            <Link to="/" className="hover:text-primary-700">首页</Link>
            <span className="mx-2">/</span>
            <span className="text-foreground-700">追更指南</span>
          </nav>
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">追更指南与常见问题</h1>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            关于今日同人库的更新机制、汉化进度与订阅方式，这里整理了读者最常问的问题。
          </p>
        </div>
      </div>

      <div className="px-4 md:px-6 max-w-4xl mx-auto py-10">
        <div className="space-y-3">
          {faqs.map((f) => (
            <details key={f.q} className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden">
              <summary className="flex items-center justify-between gap-3 px-5 py-4 cursor-pointer list-none">
                <span className="font-heading text-base font-semibold text-foreground-900">{f.q}</span>
                <i className="ri-add-line text-xl text-foreground-400 group-open:rotate-45 transition-transform shrink-0"></i>
              </summary>
              <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{f.a}</p>
            </details>
          ))}
        </div>

        <div className="mt-10 bg-background-100 rounded-lg p-6 md:p-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <h2 className="font-heading text-lg font-semibold text-foreground-900">还有其它问题？</h2>
            <p className="mt-1 text-sm text-foreground-500">欢迎随时联系我们，我们会尽快为你解答。</p>
          </div>
          <Link
            to="/contact"
            className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            联系我们
          </Link>
        </div>
      </div>
    </>
  );
}